import { useState } from 'react';
import type React from 'react';

import { Waypoint } from '#src/app/shared/components/scroll';
import { RoundShareIconButton } from '#src/app/shared/components/share';

import { useShareLinks } from './hooks/useShareLinks';

export const ShareLinks: React.FC<EmptyProps> = () => {
	const [visible, setVisible] = useState(false);
	const {
		data: { buttonConfigs },
	} = useShareLinks({ disableShortLinks: !visible });

	return (
		<>
			<Waypoint onEnter={() => setVisible(true)} />
			<div className="grid w-full grid-cols-[repeat(auto-fill,minmax(4.5rem,1fr))] items-center justify-items-center gap-x-2 gap-y-1 lg:gap-x-4">
				{buttonConfigs.map((buttonConfig) => (
					<RoundShareIconButton
						key={buttonConfig.channel}
						buttonConfig={buttonConfig}
						data-qa={`update-share-${buttonConfig.channel}`}
						data-testid={`update-share-${buttonConfig.channel}`}
						className="min-w-18"
					/>
				))}
			</div>
		</>
	);
};
